import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../BasePanelPage";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";
import {Messages} from "../../../../../Messages";
import {Link} from "../../../../../../stem-core/src/ui/UIPrimitives";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {donateMobileState} from "../../../../inline-donation/DonateMobileState";
import {DonationSuccessPanelStyle} from "../DonationSuccessPanel";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {styleRuleInherit} from "../../../../../../stem-core/src/decorators/Style";
import {Router} from "../../../../../../stem-core/src/ui/Router";
import {MessageElement} from "../../../../../widget/ui/MessageElement";


class CancelDonationPanelStyle extends DonationSuccessPanelStyle {
    @styleRuleInherit
    title = {
        textAlign: "",
    };

    @styleRuleInherit
    button = {
        textTransform: "",
    };
}

@registerStyle(CancelDonationPanelStyle)
export class CancelDonationPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.donatePageCancelDonationTitle,
        };
    }

    render() {
        const {styleSheet} = this;
        const publicationName = iFrameMerchantService.getMerchant().name;

        return [
            <MessageElement className={styleSheet.message}
                            message={Messages.donatePageCancelDonationText1(publicationName)}/>,
            <div className={styleSheet.message}>{Messages.donatePageCancelDonationText2(publicationName)}</div>,
            <MerchantButton onClick={() => donateMobileState.cancel()}
                            className={styleSheet.button}>
                {Messages.donatePageCancelDonationButton}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <Link value={Messages.takeMeBack} className={styleSheet.secondaryButton}
                      onClick={() => Router.back()} />
            </div>,
        ];
    }
}
